import React from "react";

const Maintenance = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 maintenancePage shadow-lg">
      <div className="text-center p-6 bg-white rounded-2xl">
        <h1 className="text-3xl font-bold text-red-600">🚧 Under Maintenance 🚧</h1>
        <p className="mt-4 text-gray-600">
          Website is currently under maintenance. Please check after some time.
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
